import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoanVerificationForm } from "@/components/LoanVerificationForm";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoanVerificationForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
